import React, { createContext, useState, useEffect } from "react";
import api from "../api";
import Swal from "sweetalert2";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  // Fetch current user on app load
  const fetchUser = async () => {
    try {
      const res = await api.get("http://api.righttracklb.com/auth/me", {
        withCredentials: true,
      });
      setUser(res.data);
    } catch {
      setUser(null);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  // Login function
  const login = async (email, password) => {
    try {
      const res = await api.post(
        "http://api.righttracklb.com/auth/login",
        { email, password },
        { withCredentials: true }
      );

      await fetchUser();

      Swal.fire({
        title: "Login Successful",
        text: res.data.message || "Welcome back!",
        icon: "success",
        confirmButtonText: "Continue",
        confirmButtonColor: "#993400",
      });

      return true;
    } catch (err) {
      Swal.fire({
        title: "Login Failed",
        text: err.response?.data?.message || "Login failed",
        icon: "error",
      });
      return false;
    }
  };

  // Logout function
  const logout = async () => {
    try {
      await api.post("http://api.righttracklb.com/auth/logout", {}, { withCredentials: true });
      setUser(null);
      Swal.fire({
        title: "Logged out",
        text: "You have been logged out successfully",
        icon: "success",
      });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <UserContext.Provider value={{ user, setUser, login, logout }}>
      {children}
    </UserContext.Provider>
  );
};